var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBottombarProfile = function SvgBottombarProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 6a3.25 3.25 0 1 0 6.5 0 3.25 3.25 0 0 0-6.5 0M5.75 17c0 1.076.61 2.12 1.736 2.925S10.206 21.25 12 21.25s3.388-.52 4.514-1.325S18.25 18.075 18.25 17c0-1.076-.61-2.12-1.736-2.925S13.794 12.75 12 12.75s-3.388.52-4.514 1.325S5.75 15.925 5.75 17"
  })));
};
export default SvgBottombarProfile;